import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ShieldAlert, ExternalLink, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WarnZeile = ({ w, darfQuittieren, onQuittiert }) => {
  const quittieren = async () => {
    const grund = window.prompt(`Warum ist „${w.kategorie_label}“ bei ${w.name || "diesem Teilnehmer"} kein Verlust? (wird protokolliert)`);
    if (!grund?.trim()) return;
    try {
      await axios.post(`${API}/dokument-waechter/quittieren`, { key: w.key, grund });
      toast.success("Warnung quittiert");
      onQuittiert();
    } catch (e) { toast.error(e.response?.data?.detail || "Quittieren fehlgeschlagen"); }
  };
  return (
    <li className="py-2.5 flex flex-wrap items-center justify-between gap-3 text-sm" data-testid={`waechter-zeile-${w.key}`}>
      <div className="min-w-0">
        <p className="font-medium text-stone-900">{w.name || "(ohne Name)"} <span className="font-normal text-stone-500">· {w.kurs || "kein Kurs"}</span></p>
        <p className="text-xs text-stone-600">
          <b className="text-[#B4502F]">{w.kategorie_label} fehlt</b> – „{w.filename}“ wurde {w.art}{w.datum ? ` am ${new Date(w.datum).toLocaleString("de-DE")}` : ""}
        </p>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <a href={`/teilnehmer?id=${w.teilnehmer_id}`} className="inline-flex items-center gap-1 text-xs font-medium text-[#B4502F] hover:underline" data-testid={`waechter-oeffnen-${w.key}`}>
          <ExternalLink size={12} /> Akte öffnen und wiederherstellen
        </a>
        {darfQuittieren && (
          <button onClick={quittieren} className="inline-flex items-center gap-1 text-xs text-stone-600 hover:text-stone-900" data-testid={`waechter-quittieren-${w.key}`}>
            <Check size={12} /> Kein Verlust
          </button>
        )}
      </div>
    </li>
  );
};

export const DokumentWaechter = ({ rolle }) => {
  const [liste, setListe] = useState([]);
  const [alle, setAlle] = useState(false);
  const laden = () => axios.get(`${API}/dokument-waechter`).then((r) => setListe(r.data)).catch(() => setListe([]));
  useEffect(() => { laden(); }, []);
  if (!liste.length) return null;
  const sichtbar = alle ? liste : liste.slice(0, 5);
  return (
    <div className="mb-6 rounded-xl border border-[#F0C9B8] bg-[#FBEDE7] p-4" data-testid="dokument-waechter">
      <div className="flex items-start gap-3">
        <ShieldAlert className="h-5 w-5 text-[#B4502F] shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-stone-900" data-testid="dokument-waechter-titel">
            Dokument-Wächter: {liste.length} audit-relevante{liste.length === 1 ? "s Dokument fehlt" : " Dokumente fehlen"} plötzlich
          </p>
          <p className="text-xs text-stone-600">Bildungsgutschein, Anwesenheitsliste, Prüfung, Maßnahme-/Praktikumsvertrag, Laufzettel oder Zertifikat wurde gelöscht oder archiviert – und es gibt keinen Ersatz in der Akte.</p>
          <ul className="mt-2 divide-y divide-[#F0C9B8]">
            {sichtbar.map((w) => <WarnZeile key={w.key} w={w} darfQuittieren={["gf", "verwaltung"].includes(rolle)} onQuittiert={laden} />)}
          </ul>
          {liste.length > 5 && (
            <button onClick={() => setAlle(!alle)} className="mt-1 text-xs font-medium text-stone-700 hover:underline" data-testid="dokument-waechter-alle">
              {alle ? "Weniger anzeigen" : `Alle ${liste.length} anzeigen`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
